export default "__VITE_ASSET__DQhWlxXS__"